import React, { useCallback } from 'react'
import { Box, Button } from '@mui/material';
import { GridToolbarContainer, GridToolbarFilterButton,GridToolbarDensitySelector } from "@mui/x-data-grid-premium";
import Api from '../../../services/Api';
import * as XLSX from 'xlsx';
import moment from 'moment';

const CustomToolbar = ({ apiRef,formFilters,filterModel,isLoading,setIsLoading }) => {
    const api = new Api();
    const handleExport = useCallback(async () => {
        try{
        // Get current filters and sorting
        setIsLoading(true);
        
        const sortModel = apiRef.current.getSortModel();
        const { page, pageSize } = apiRef.current.state.pagination.paginationModel;
  
        // Prepare export parameters
        const params = new URLSearchParams({
          ...formFilters,
          filters: JSON.stringify(filterModel),
          sort: JSON.stringify(sortModel),
        });
  
        
       const { status , errors ,data }  = await api.apiData('get',"/paiement/apc/export",{ params });
       if( status === 200 ){
        if( data.length > 0 ){
            const workbook = XLSX.utils.book_new();
            const _data = data.map((dt, index) => {
                return {
                    "Ordre": index + 1,
                    "Identifiant": dt.paiement_id,
                    "Reference": dt.reference,
                    "Type de Demandeur": dt.typeDemandeur,
                    "Prenom et Nom/Société" : dt.fullName,
                    Telephone:dt.telephone,
                     Nif: dt.nif || "Non fournie",
                    "Denomination": dt.denominationSociete || "Non fournie",
                    "marque": dt.marque,
                    "modele":dt.modele,
                    "Nummer de Chassis": dt.numeroChassis,
                    "Date Première en Circulation": dt.dateMiseCirculation,
                    Provenance: dt.paysProvenance,
                    Destination: dt.paysDestination,
                    Status: dt.status?.charAt(0).toUpperCase() + dt.status?.slice(1),
                    "Date d'expiration" : moment(dt.dateExpiration).format("DD/MM/YYYY"),
                    "Date de création" : moment(dt.created_at).format("DD/MM/YYYY"),

                }
            });
            const worksheet = XLSX.utils.json_to_sheet(_data);
            // Add worksheet to workbook
           XLSX.utils.book_append_sheet(workbook, worksheet, 'Statistique');
           XLSX.writeFile(workbook, 'export_' + moment().format('dddd-Do-MMMM-YYYY')  + '.xlsx');
        }
       }
       
     }
     catch(e){
        console.log(e)
     }
     finally{
        setIsLoading(false);
     }
    }, [apiRef, formFilters]);   
  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />  
      <GridToolbarDensitySelector />
    <Box sx={{ display: 'flex'}}>
      <Button 
        variant="text" 
       onClick={handleExport}
        disabled={isLoading}
      >
        Exporter
      </Button>
  
    </Box>
  
  </GridToolbarContainer>
  )
}

export default CustomToolbar
